import { render, staticRenderFns } from "./AuthorizedLayout.vue?vue&type=template&id=1d3540e3"
import script from "./AuthorizedLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizedLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedLayout.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports